export default __webpack_public_path__ + "static/media/26.182afa19.PNG";